import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MotifAlert from '@liveramp/motif/core/Alert';
import { closeAlert } from 'shared/store/features/alertSlice';
import { RootState } from 'shared/store/rootReducer';
import styles from './styles.module.scss';

// eslint-disable-next-line max-len
export const cookieBanner = '. Please enable third party cookies in your browser settings or contact your LiveRamp representative for assistance.';

const Alert: FunctionComponent = () => {
  const alertState = useSelector(
    (state: RootState) => state.alert
  );
  const dispatch = useDispatch();

  return (
    <MotifAlert
      className={styles.alert}
      {...alertState}
      onClose={() => dispatch(closeAlert())}
      data-test-id={`${alertState.variant}-alert`}
    >
      {alertState.text}
    </MotifAlert>
  );
};

export default Alert;
